export default __webpack_public_path__ + "static/media/csango10-ujepitesu-lakasok.89a758e6.webp";